module.exports = __webpack_public_path__ + "static/media/190x190px_normal.480ebac5.png";